<template>
   <div class="">
    <button class="mr-3 btn  "
        @click="closeShift"
        :class="[data.closed ? 'btn-default' : 'btn-warning']"
        :disabled="data.closed ? true : false"
    >
       {{!data.closed ? 'Close Shift' : 'Shift closed'}}
    </button>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
      
  },
  methods: {
    closeShift($event) {
      this.$eventHub.$emit("closeShift", this.data)
    },
    
  },
};

</script>